import { QuebecOption } from '~src/domains/common/enums/common';
import { InputLocalizationType } from '~src/domains/common/types/forms';
import { createDefaultFormMeta, createFormMetaSlice } from '~src/utils/forms';
import { InvalidAddressOption } from '../enums/invalidAddress';

export type InvalidAddressLocalization = {
  [key: string]: InputLocalizationType;
};

const formMetaDefault = createDefaultFormMeta([
  [InvalidAddressOption.ADDRESS],
  [InvalidAddressOption.CITY],
  [InvalidAddressOption.REGION],
  [InvalidAddressOption.POSTAL_CODE],
  [QuebecOption.MONTHLY_HOUSING_COST],
  [QuebecOption.PRIMARY_INCOME_SOURCE],
  [QuebecOption.OCCUPATION],
  [QuebecOption.EMPLOYMENT_DURATION],
]);

export const invalidAddressFormSlice = createFormMetaSlice(
  'invalidAddress',
  formMetaDefault,
);

export const {
  updateInputValue,
  updateInputHidden,
  updateInputIsValid,
  registerInputLabel,
  registerValidityConfig,
  registerPostProcess,
} = invalidAddressFormSlice.actions;

export default invalidAddressFormSlice.reducer;
